export const NAME = 'curriculum';

const SET_CURRENT_SELECTED_CLASS_DETAILS = `SET_CURRENT_SELECTED_CLASS_DETAILS_${NAME}`;

export const setCurrentSelectedClass = (data) => {
	return {
		type: SET_CURRENT_SELECTED_CLASS_DETAILS,
		payload: data,
	};
};

const ACTION_MAP = {
	[SET_CURRENT_SELECTED_CLASS_DETAILS]: (state, action) => {
		return {
			...state,
			currentSelectedClass: action.payload,
		};
	},
};

const initialState = {
	currentSelectedClass: null,
};

export const reducer = (state = initialState, action) => {
	const actionFunc = ACTION_MAP[action.type];

	return actionFunc ? actionFunc(state, action) : state;
};
